<form [formGroup]="form">
    <div class="flex flex-col justify-center items-center pt-10 gap-5">
        <mat-card
            class="!bg-neutral-100 !rounded-lg py-9 px-14 w-100p md:w-80p lg:w-60p xl:w-40p"
        >
            <div class="flex justify-center items-center">
                <h1>Locate Contact</h1>
            </div>
            <div class="flex flex-col items-center w-full">
                <mat-form-field
                    appearance="outline"
                    class="field-responsive-width"
                >
                    <mat-label>Search by Last Name</mat-label>
                    <input
                        title="Last name"
                        matInput
                        formControlName="lastName"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="64"
                    />
                    @if (form.controls.lastName.value) {
                        <button
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="form.controls.lastName.reset()"
                            tabindex="-1"
                            type="button"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field
                    appearance="outline"
                    class="field-responsive-width"
                >
                    <mat-label>Search by First Name</mat-label>
                    <input
                        title="First name"
                        matInput
                        formControlName="firstName"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="64"
                    />
                    @if (form.controls.firstName.value) {
                        <button
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="form.controls.firstName.reset()"
                            tabindex="-1"
                            type="button"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                </mat-form-field>
                <mat-form-field
                    appearance="outline"
                    class="field-responsive-width"
                >
                    <mat-label>Search by Company</mat-label>
                    <input
                        title="Company/Organization name"
                        matInput
                        formControlName="organizationName"
                        (ngModelChange)="onOrganizationInputChange($event)"
                        [matAutocomplete]="auto"
                        maxLength="128"
                    />
                    @if (form.controls.organizationName.value) {
                        <button
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="this.clearOrganizationSearch()"
                            tabindex="-1"
                            type="button"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    }
                    <mat-autocomplete
                        autoActiveFirstOption
                        #auto="matAutocomplete"
                    >
                        @for (
                            organization of filteredOrganizations;
                            track organization
                        ) {
                            <mat-option [value]="organization.name"
                                >{{ organization.name }} -
                                {{ organization.city }},
                                {{ organization.state }}</mat-option
                            >
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <button
                    mat-button
                    mat-flat-button
                    color="primary"
                    class="field-responsive-width"
                    [disabled]="!allowForContactSearch()"
                    (click)="populateContactDropdownOptions()"
                    type="button"
                >
                    Search
                </button>
                <mat-form-field
                    appearance="outline"
                    class="field-responsive-width mt-5"
                >
                    <mat-label>Select Contact</mat-label>
                    <mat-select formControlName="civiContactId">
                        @for (
                            contactOption of contactDropdownOptions();
                            track contactOption.value
                        ) {
                            <mat-option [value]="contactOption.value">{{
                                contactOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <button
                    mat-button
                    mat-flat-button
                    color="primary"
                    class="field-responsive-width"
                    [disabled]="!form.controls.civiContactId.value"
                    (click)="evaluateContactStatus()"
                    type="button"
                >
                    Start Application
                </button>
            </div>
        </mat-card>
        @if (billingNotesForSelectedContact()) {
            <div class="w-100p md:w-80p lg:w-60p xl:w-40p mb-10">
                <h2>Billing Notes</h2>
                {{ billingNotesForSelectedContact() }}
            </div>
        }
    </div>
</form>
